import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Terms from '../components/Terms';
import FAQ from '../components/FAQ';
import About from '../components/About';
import Home from "../components/Home";
import Login from "../components/Login";
import Payment from "../components/Payment";
import { useAuth } from "../context/AuthContext";
import Add from '../components/Dashboard/Add';
import FnT from '../components/Dashboard/FnT';
import Dashboard from '../components/Dashboard';
import ThankYou from '../components/Thankyou';
import JoinUs from '../components/JoinUs';

const PrivateRoutes = ({ condition, component: Comp, ...rest }) => {
  return (
    <Route {...rest} component={(props) => condition ? <Comp {...props} /> : <Redirect to="/login" />}/>
  );
};

const PublicRoutes = ({ user, component: Comp,restricted=false, ...rest }) => {
  return (
    <Route {...rest} component={(props) => restricted ? (user ? (<Redirect to="/dashboard" />) : (<Comp {...props} />)) : (<Comp {...props} />)}/>
  );
};

const Routes = () => {
  const { isAuth } = useAuth();
  return (
    <>
    <Switch>
      <PrivateRoutes condition={isAuth} exact path="/panel/:page/add" component={Add} />
      <PrivateRoutes condition={isAuth} exact path="/panel/:page/edit/:id" component={Add} />
      <PrivateRoutes condition={isAuth} exact path="/dashboard" component={Dashboard} />
      <PrivateRoutes condition={isAuth} exact path="/panel/:input/create" component={Add} />
      <PrivateRoutes condition={isAuth} exact path="/panel/:component/set" component={Add} />
      <PrivateRoutes condition={isAuth} exact path="/panel/:input/modify/:id" component={Add} />
      <PrivateRoutes condition={isAuth} exact path="/panel/:page/display" component={FnT} />
      <PrivateRoutes condition={isAuth} exact path="/panel/:component/show" component={FnT} />
      <PrivateRoutes condition={isAuth} exact path="/panel/:input/preview" component={FnT} />
      <PublicRoutes user={isAuth} component={Home} path="/" exact />
      <PublicRoutes user={isAuth} component={JoinUs} path="/join_us" exact />
      <PublicRoutes user={isAuth} component={FAQ} path="/faq" exact />
      <PublicRoutes user={isAuth} component={ThankYou} path="/thankyou" exact />
      <PublicRoutes condition={isAuth} component={About} path="/about" exact />
      <PublicRoutes condition={isAuth} component={Terms} path="/terms" exact />
      <PublicRoutes condition={isAuth} component={Payment} path="/Payment" exact />
      <PublicRoutes restricted user={isAuth} exact path="/login" component={Login} />
    </Switch>
    </>
  );
};

export default Routes;